<template>
  <div>
    <v-client-table key="dxGrid" class="hiaTable" ref="dxGrid" id="dxGrid" :data="worksheet.dxs" :columns="columns" :options="options" uniqueKey="dxId">

      <template slot="originalDx" slot-scope="props">
        <div>
          <!-- <el-input style="width: 112px;" :inputId="`originalDx_${props.index}`" class="noRightBorder borderLeftRadius" v-model="props.row.originalDx" :disabled="disabled">
          </el-input> -->

          {{props.row.originalDx}}
        </div>
      </template>

      <template slot="originalPoa" slot-scope="props">
        <div style="text-align: center;">{{ props.row.originalPOA }}</div>
      </template>

      <template slot="originalDescription" slot-scope="props">
        <div style="text-transform: lowercase;">{{props.row.originalDescription}} <span v-if="props.row.originalGrouperFlags" :title="getGrouperflagsTitle(props.row.originalGrouperFlags)" class="grouperFlags">({{props.row.originalGrouperFlags}})</span></div>
      </template>

      <template slot="recommendedDx" slot-scope="props">
        <div>
          <!-- <el-input disabled style="width: 112px;" :placeholder="props.row.originalDx" :inputId="`recommendedDx_${props.index}`" :class="{deleteCode: props.row.deleteCode}"
            :value="props.row.originalDeleted ? 'DEL' : props.row.recommendedDx" @ellipsisClick="emitEllipsisClick(props.row.recommendedDx)"
            @focus="emitFocusedCode(props.row.recommendedDx)">
          </el-input> -->

          {{props.row.originalDeleted ? 'DEL' : props.row.recommendedDx}}
        </div>
      </template>

      <template slot="recommendedPoa" slot-scope="props">
        <div style="text-align: center;">{{ props.row.recommendedPOA }}</div>
      </template>

      <template slot="recommendedDesc" slot-scope="props">
        <div style="text-transform: lowercase;">{{props.row.originalDeleted ? 'Delete Code' : props.row.recommendedDesc}} <span :title="getGrouperflagsTitle(props.row.recommendedGrouperFlags)" v-if="((props.row.recommendedDx && props.row.recommendedGrouperFlags) || (props.row.recommendedGrouperFlags && props.row.recommendedGrouperFlags !== props.row.originalGrouperFlags))" class="grouperFlags">({{props.row.recommendedGrouperFlags}})</span></div>

      </template>

      <template slot="reasonForChange" slot-scope="props">
        <!-- <el-input style="width: 82%" :disabled="disabled" @input="putInpatientDx(props.row, $event)" v-model="props.row.reasonForChange" placeholder="Reason for Change">
        </el-input> -->

        {{props.row.reasonForChange}}
      </template>

      <template slot="response" slot-scope="props">
        <el-button :disabled="coderResponsesReadOnly()" style="margin-right: 5px;" size="mini" v-if="props.row.recommendedDx || props.row.originalDeleted || props.row.recommendedPOA" type="text" @click="addResponse(props.row)">Respond
        </el-button>
      </template>

    </v-client-table>

  </div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import dateHelper from '@/mixins/date-helper'
  import HiaAuthorization from '@/mixins/hiaAuthorization'
  import coderReviewStatusHelper from '@/mixins/coderReviewStatusHelper'
  import { format, parseISO } from 'date-fns'

  export default {
    name: 'coderInpatientDxs',
    mixins: [dateHelper, HiaAuthorization, coderReviewStatusHelper],
    props: ['worksheet'],
    data() {
      return {
        format: format,
        parseISO: parseISO,
        disabled: true,
        loading: false,
        columns: ['originalDx', 'originalPoa', 'originalDescription', 'recommendedDx', 'recommendedPoa', 'recommendedDesc', 'reasonForChange', 'response'],
        options: {
          filterable: false,
          filterByColumn: false,
          resizableColumns: false,
          queue: [],
          networkFunction: null,
          perPage: 100,
          rowClassCallback: row => {
            if (row.recommendedDx || row.originalDeleted || row.newPrimary || row.recommendedPOA) {
              return 'highlight'
            }
            return ''
          },
          columnsClasses: {
            originalDx: 'codeCol',
            originalPoa: 'fiftyPx',
            originalDescription: 'twentyFivePercent',
            recommendedDx: 'codeCol',
            recommendedPoa: 'fiftyPx',
            recommendedDesc: 'twentyFivePercent',
            reasonForChange: 'reasonForChangeCol'
          },
          headings: {
            originalDx: 'Orig. Dx',
            originalPoa: 'POA',
            recommendedDx: 'Rec. Dx',
            recommendedPoa: 'POA',
            originalDescription: 'Desc.',
            recommendedDesc: 'Desc.',
            reasonForChange: 'Reason For Change',
            response: ''
          }
        }
      }
    },
    methods: {
      ...mapMutations('coder/', ['SET_RESPONSE_ROW']),
      getGrouperflagsTitle(flagList) {
        if (!flagList) {
          return
        }

        const flagMap = {
          AD: 'Affects DRG',
          CC: 'Complication/Comorbidity',
          HC: 'Hospital-Acquired Condition',
          MC: 'Complication/Comorbidity',
          R: 'Affects Risk of Mortality',
          S: 'Affects Severity of Illness',
          AP: 'Affects Patient Safety Indicators',
          EP: 'Excludes Patient Safety Indicators',
          AQ: 'Affects Quality Measures',
          EQ: 'Excludes Quality Measures'
        }

        const flags = flagList.split(',')
        const title = []
        flags.forEach(x => {
          title.push(`${x}: ${flagMap[x]}`)
        })

        return title.join('\n')
      },
      addResponse(row) {
        this.SET_RESPONSE_ROW(row)
      }
    }
  }
</script>

<style scoped>
.grouperFlags {
  font-style: italic;
  text-transform: uppercase;
}

>>> .twentyFivePercent {
  min-width: 25%;
}

>>> .reasonForChangeCol {
  min-width: 120px;
}

>>> .highlight {
  /* background-color: rgba(255, 196, 12, 0.1) !important; */
  font-weight: bold;
}

>>> .highlight {
  border-left: 3px solid #f56c6c;
}

/* >>>.highlight:hover {
    background-color: rgba(255, 196, 12, 0.2) !important;
  } */

/* >>>.codeCol {
    min-width: 80px;
  } */

>>> td {
  font-size: 13px !important;
}
</style>
